<!-- <app-topbar></app-topbar> -->
<lib-toastify-toast-container
  [transition]="'flip'"
  [hideProgressBar]="true"
  [newestOnTop]="true"
  [iconLibrary]="'material'"
></lib-toastify-toast-container>
<router-outlet></router-outlet>
